'use client';

import { memo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { LocalShipping, Scale } from '@mui/icons-material';
import { themeColors } from '../../../theme/theme';

/**
 * Parcel details section (type, weight)
 */
const ParcelDetailsSection = memo(({ itemType, weight }) => {
  const displayType = Array.isArray(itemType) ? itemType.join(', ') : itemType || 'Package';
  const displayWeight = weight ? `${weight} kg` : 'N/A';

  return (
    <Stack direction="row" spacing={3} alignItems="center">
      <Stack direction="row" spacing={0.8} alignItems="center">
        <LocalShipping sx={{ fontSize: 16, color: themeColors.primaryColor, opacity: 0.7 }} />
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: 10, display: 'block', lineHeight: 1.2 }}
          >
            Type
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
            {displayType}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={0.8} alignItems="center">
        <Scale sx={{ fontSize: 16, color: '#ff9800', opacity: 0.7 }} />
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: 10, display: 'block', lineHeight: 1.2 }}
          >
            Weight
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
            {displayWeight}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
});

ParcelDetailsSection.displayName = 'ParcelDetailsSection';

export default ParcelDetailsSection;
